<div class="bg-black" style="border-top: 1px solid black">
  <p
    style="font-size: 14px"
    class="text-center text-light font-weight-bold p-1 pb-0"
  >
    © Copyright 2016. All Rights Reserved. Powered by {{ host | uppercase }}.
    info@{{ host }}.com
  </p>
</div>
